<template>
  <deals-Items :cart="cart" :coupons="coupons" :isHome="false" ></deals-Items>
</template>
<script>
import DealsItems from '@/views/components/DealsItems'
export default {
  name:'deals',
  components: {
    DealsItems
  },
  props: {
    cart: Object,
    coupons:Array

  },
  mounted() {
  }
};
</script>
